"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var LaborUnionLocalResource = /** @class */ (function (_super) {
    tslib_1.__extends(LaborUnionLocalResource, _super);
    function LaborUnionLocalResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LaborUnionLocalResource.endpoint = '/laborunionlocals';
    LaborUnionLocalResource.MODEL_NAME = 'laborunionlocal';
    return LaborUnionLocalResource;
}(base_1.default));
exports.default = LaborUnionLocalResource;
//# sourceMappingURL=laborunionlocal.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/laborunionlocal.js
// module id = 46my
// module chunks = 0